import React from "react";
import { Container, Row, Col, Card, Button } from "react-bootstrap";
import { motion } from "framer-motion";
import { useNavigate } from "react-router-dom";
import "../assets/styles/FeaturedInsights.css";

const insights = [
  {
    title: "Adopt AI Today or Get Left Behind: Why Your Business Needs It Now!",
    image: './assets/aiFeatured.jpg',
    url: "/blogs/Details", // Internal route for AI article
    isExternal: false,
  },
  {
    title: "Thriving with Remote Teams: How Virtual Hiring Surpasses Traditional Outsourcing!",
    image: './assets/programingFeatured.jpg',
    url: "/blogs/Details", // Internal route for remote teams article
    isExternal: false,
  },
  {
    title: "From Code to Success: How Software Products Transformed Business Growth",
    image: './assets/aiFeaturedPic.jpeg',
    url: "/blogs/Details", // Internal route for software products article
    isExternal: false,
  },
];

const cardVariants = {
  hidden: { opacity: 0, y: 50 },
  visible: { opacity: 1, y: 0, transition: { duration: 0.6 } },
  hover: { scale: 1.05, transition: { duration: 0.3 } },
};

const FeaturedInsights = () => {
  const navigate = useNavigate();

  const handleViewDetails = (insight) => {
    if (insight.isExternal) {
      // Open external URL in new tab
      window.open(insight.url, "_blank");
    } else {
      // Navigate to internal route
      navigate(insight.url);
    }
  };

  return (
    <section className="featured-insights">
      <Container>
        <h2 className="section-title">Featured Insights</h2>
        <p className="section-description">
          Experience effortless collaboration with our cloud memberships, crafted to equip virtual teams with scalable, high-performance solutions for enhanced productivity.
        </p>
        <Row className="g-4">
          {insights.map((insight, index) => (
            <Col md={4} key={index}>
              <motion.div
                initial="hidden"
                animate="visible"
                whileHover="hover"
                variants={cardVariants}
              >
                <Card className="insight-card">
                  <div className="insight-image" style={{ backgroundImage: `url(${insight.image})` }}>
                    <div className="overlay">
                      <div className="overlay-content top">
                        <h3 className="insight-title">{insight.title}</h3>
                      </div>
                      <Button
                        variant="outline-light"
                        className="featured-view-details"
                        onClick={() => handleViewDetails(insight)}
                      >
                        View Details
                      </Button>
                    </div>
                  </div>
                </Card>
              </motion.div>
            </Col>
          ))}
        </Row>
      </Container>
    </section>
  );
};

export default FeaturedInsights;

